module.exports = __webpack_public_path__ + "static/media/TCS.73b192d3.png";